import script from "./Attendance.vue?vue&type=script&setup=true&lang=js"
export * from "./Attendance.vue?vue&type=script&setup=true&lang=js"

import "./Attendance.vue?vue&type=style&index=0&id=32358e3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32358e3e"]])

export default __exports__